<template>
  <div class="statistic">
    <h3 class="text-black text-sm">預計訂購人數</h3>
    <div class="flex justify-around mt-2">
      <div
        v-for="(info, index) in infos"
        :key="`expected-order-count-${index}`"
        class="statistic__subtitle"
      >
        <span class="mb-2 text-gray-500 text-sm">
          {{ info.title }}
        </span>
        <span :class="info.classes" class="text-2xl">
          {{ info.value }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import ExpectedOrderCount from './ExpectedOrderCount';

export default ExpectedOrderCount;
</script>

<style lang="scss" scoped>
@import 'ExpectedOrderCount';
</style>
